import React, { useEffect, useState } from "react";
import { number, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import "./notLoggedInView.m.css";

const NotLoggedInView = ({ authHost, clientId }) => {
  const [callbackUrlLink, setCallbackUrlLink] = useState("");
  const [redirectUrlLink, setRedirectUrlLink] = useState("");

  useEffect(() => {
    setCallbackUrlLink(global?.location?.href);
    setRedirectUrlLink(global?.location?.origin);
  }, []);

  return (
    <div styleName="not-logged-view">
      <a
        styleName="button"
        href={`${authHost}/api/auth/v1/oauth/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUrlLink}/api/auth/v1/oauth/token&callback_uri=${callbackUrlLink}`}
        rel="nofollow"
      >
        Click here to login
      </a>
    </div>
  );
};

NotLoggedInView.propTypes = {
  authHost: string,
  clientId: number,
};

const mapStateToProps = (state) => ({
  clientId: get(state, ["qt", "config", "publisher-attributes", "sso_login", "client_id"], ""),
  authHost: get(state, ["qt", "config", "publisher-attributes", "auth_host"], null),
});

export default connect(mapStateToProps)(NotLoggedInView);
